import styled from 'styled-components';

import { theme } from '@notino/react-styleguide-v20';

import { Bold } from '@styles/generalStyles';

export const StyledDescription = styled.span`
  color: ${theme.color.text.secondary};
`;

export const StyledTitleText = styled(Bold)`
  display: block;
`;
